import React, { useState, useEffect } from "react";
import { Main, Content, SubContent } from "../../../components/Layout";
import { Col, Row } from "react-bootstrap";
import IcEditar from "../../../components/Svg/IcEditar";
import api from "../../../services/api";
import Accordion from "../../../components/Accordion";
import styleButton from "../../../components/Button/Button.module.css";
import Loading from "../../../components/Loading";
import { toast } from "react-toastify";
import useWrapper from "../../../hooks/useWrapper";

export default function AdminEvents() {
  const { setbreadcrumb, config } = useWrapper();

  const [loadingPage, setLoadingPage] = useState(true);
  const [reload, setreload] = useState(false);

  const [categories, setcategories] = useState();
  const [categoriesAttendance, setcategoriesAttendance] = useState();

  useEffect(() => {
    api
      .get("categories?only_attendance=0", config)
      .then(resp => {
        let _categories = resp.data.data;
        _categories = _categories.map(__category => {
          let _resources = __category.resource;
          _resources = _resources.sort((a, b) => {
            return a.name.localeCompare(b.name);
          });
          return {
            ...__category,
            resource: _resources,
          };
        });
        _categories = _categories.sort((a, b) => {
          return a.name.localeCompare(b.name);
        });
        setcategories(_categories);
      })
      .then(() => {
        api
          .get("categories?only_attendance=1", config)
          .then(resp => {
            let _categories = resp.data.data;
            _categories = _categories.map(__category => {
              let _resources = __category.resource;
              _resources = _resources.sort((a, b) => {
                return a.name.localeCompare(b.name);
              });
              return {
                ...__category,
                resource: _resources,
              };
            });
            _categories = _categories.sort((a, b) => {
              return a.name.localeCompare(b.name);
            });
            setcategoriesAttendance(_categories);
          })
          .then(() => {
            setLoadingPage(false);
          });
      });
    // config is recreated on every WrapperContext render; only re-fetch when `reload` changes
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reload]);

  const createCategory = e => {
    if (!e.name) {
      setreload(!reload);
    } else if (!e.id) {
      api
        .post(
          "categories",
          {
            name: e.name,
            only_attendance: e.only_attendance,
            main_events: e.main_events,
          },
          config,
        )
        .then(() => {
          toast.success(`Nova Categoria "${e.name}" criada com sucesso!`);
          setreload(!reload);
        });
    } else {
      api
        .put(
          `categories/${e.id}`,
          {
            name: e.name,
            only_attendance: e.only_attendance,
            main_events: e.main_events,
          },
          config,
        )
        .then(() => {
          toast.success(`Categoria "${e.name}" editada com sucesso!`);
          setreload(!reload);
        });
    }
  };

  const createResource = e => {
    if (!e.name) {
      setreload(!reload);
    } else if (!e.id) {
      api
        .post(
          "resources",
          {
            name: e.name,
            id: e.id,
            category_id: e.category_id,
          },
          config,
        )
        .then(() => {
          toast.success(`Novo ${e.only_attendance ? "Atendimento" : "Recurso"} "${e.name}" criado com sucesso!`);
          setreload(!reload);
        });
    } else {
      api
        .put(
          `resources/${e.id}`,
          {
            name: e.name,
            id: e.id,
            category_id: e.category_id,
          },
          config,
        )
        .then(() => {
          toast.success(`${e.only_attendance ? "Atendimento" : "Recurso"} "${e.name}" editado com sucesso!`);
          setreload(!reload);
        });
    }
  };

  useEffect(() => {
    setbreadcrumb([{ label: "Administrativo" }]);
  }, [setbreadcrumb]);

  return (
    <Main>
      {!loadingPage ? (
        <Content noBG="true">
          <SubContent>
            <Row>
              <Col>
                <>
                  <h2 className="mini-title">Gerenciar Recursos & Atendimentos</h2>
                  <p className="small-label font-italic mb-3">
                    Adicione recursos para classificar seus fornecedores e montar os orçamentos detalhados. Nós
                    fornecemos alguns mas você pode adicionar aqueles que se enquadram aos seus projetos.
                  </p>
                  <Accordion>
                    {categories &&
                      categories.map((e, i) => (
                        <Accordion.Item eventKey={i + 1}>
                          <Accordion.Header
                            eventKey={!e.editable ? i + 1 : null}
                            style={e.editable ? { borderColor: "var(--color-primary" } : {}}
                          >
                            <div
                              className={styleButton.input_button_list}
                              data-edit={e.editable}
                              style={{ border: "none", padding: "0", height: "auto" }}
                            >
                              <label style={{ cursor: "pointer" }}>
                                <input
                                  type="text"
                                  placeholder={`Novo Categoria`}
                                  value={e.name}
                                  disabled={!e.editable}
                                  autoFocus
                                  style={!e.editable ? { pointerEvents: "none" } : {}}
                                  onChange={ev => {
                                    let _categories = [...categories];
                                    _categories[i].name = ev.target.value;
                                    setcategories(_categories);
                                  }}
                                  onBlur={() => {
                                    let _categories = [...categories];
                                    createCategory({
                                      id: e.id,
                                      name: e.name,
                                      only_attendance: e.only_attendance,
                                      main_events: e.main_events,
                                    });
                                    _categories[i].editable = false;
                                    setcategories(_categories);
                                  }}
                                  onKeyDown={ev => {
                                    if (ev.keyCode === 13 || ev.keyCode === 27) {
                                      ev.target.blur();
                                    }
                                  }}
                                />
                                <button
                                  type="button"
                                  className="simple-ico mr-2"
                                  onClick={ev => {
                                    ev.stopPropagation();
                                    let _categories = [...categories];
                                    _categories[i].editable = true;
                                    setcategories(_categories);
                                  }}
                                >
                                  {!e.editable && <IcEditar />}
                                </button>
                              </label>
                            </div>
                          </Accordion.Header>
                          <Accordion.Body>
                            <Row style={{ marginTop: "-1rem" }}>
                              {e.resource.map((e2, i2) => (
                                <Col sm={6} className="mt-3">
                                  <div className={styleButton.input_button_list} data-edit={e2.editable}>
                                    <label>
                                      <input
                                        type="text"
                                        placeholder={`Novo Recurso`}
                                        value={e2.name}
                                        disabled={!e2.editable}
                                        autoFocus
                                        onChange={ev => {
                                          let _categories = [...categories];
                                          _categories[i].resource[i2].name = ev.target.value;
                                          setcategories(_categories);
                                        }}
                                        onBlur={() => {
                                          let _categories = [...categories];
                                          createResource({
                                            id: e2.id,
                                            name: e2.name,
                                            category_id: e.id,
                                          });
                                          setTimeout(function () {
                                            _categories[i].resource[i2].editable = false;
                                            setcategories(_categories);
                                          }, 100);
                                        }}
                                        onKeyPress={ev => {
                                          if (ev.charCode === 13) {
                                            ev.target.blur();
                                          }
                                        }}
                                      />
                                      <button
                                        type="button"
                                        className="simple-ico"
                                        onClick={() => {
                                          let _categories = [...categories];
                                          _categories[i].resource[i2].editable = true;
                                          setcategories(_categories);
                                        }}
                                      >
                                        {!e2.editable && <IcEditar />}
                                      </button>
                                    </label>
                                  </div>
                                </Col>
                              ))}
                              <Col sm={12}>
                                <button
                                  className={`mt-3 ${styleButton.button_add}`}
                                  colorScheme="grey"
                                  type="button"
                                  onClick={() => {
                                    let _categories = [...categories];
                                    _categories[i].resource.push({
                                      editable: true,
                                      id: null,
                                      name: "",
                                    });
                                    setcategories(_categories);
                                  }}
                                >
                                  <span>Adicionar Recurso ({e.name})</span>
                                </button>
                              </Col>
                            </Row>
                          </Accordion.Body>
                        </Accordion.Item>
                      ))}
                  </Accordion>
                  {/* <button
                    className={`mt-3 ${styleButton.button_add}`}
                    type="button"
                    colorScheme="primary"
                    onClick={() => {
                      let _categories = [...categories];
                      _categories.push({
                        editable: true,
                        id: null,
                        name: "",
                        event: [],
                        resource: [],
                        only_attendance: 0,
                        main_events: 0
                      });
                      setcategories(_categories);
                    }}
                  >
                    <span>Adicionar Categoria</span>
                  </button> */}
                </>
              </Col>
            </Row>
            {/* <h2 className="mini-title mb-1 mt-3">Categorias</h2> */}
          </SubContent>
          <SubContent className="mt-4">
            <h2 className="mini-title">Assuntos Exclusivos para Atendimento</h2>
            <p className="small-label font-italic mb-3">
              Na seção anterior, foram cadastrados recursos para cada evento. Formandos poderão abrir tickets de
              atendimento referentes àqueles recursos. Aqui você poderá criar assuntos que possam ser motivos de
              abertura de tickets para atendimento que não estejam ligados aos recursos listados na seção anterior.
            </p>
            <Accordion>
              {categoriesAttendance &&
                categoriesAttendance.map((e, i) => (
                  <Accordion.Item eventKey={i + 1}>
                    <Accordion.Header
                      eventKey={!e.editable ? i + 1 : null}
                      style={e.editable ? { borderColor: "var(--color-primary" } : {}}
                    >
                      <div
                        className={styleButton.input_button_list}
                        data-edit={e.editable}
                        style={{ border: "none", padding: "0", height: "auto" }}
                      >
                        <label style={{ cursor: "pointer" }}>
                          <input
                            type="text"
                            placeholder={`Novo Categoria`}
                            value={e.name}
                            disabled={!e.editable}
                            autoFocus
                            style={!e.editable ? { pointerEvents: "none" } : {}}
                            onChange={ev => {
                              let _categoriesAttendance = [...categoriesAttendance];
                              _categoriesAttendance[i].name = ev.target.value;
                              setcategoriesAttendance(_categoriesAttendance);
                            }}
                            onBlur={() => {
                              let _categoriesAttendance = [...categoriesAttendance];
                              createCategory({
                                id: e.id,
                                name: e.name,
                                only_attendance: e.only_attendance,
                                main_events: e.main_events,
                              });
                              _categoriesAttendance[i].editable = false;
                              setcategoriesAttendance(_categoriesAttendance);
                            }}
                            onKeyDown={ev => {
                              if (ev.keyCode === 13 || ev.keyCode === 27) {
                                ev.target.blur();
                              }
                            }}
                          />
                          <button
                            type="button"
                            className="simple-ico mr-2"
                            onClick={ev => {
                              ev.stopPropagation();
                              let _categoriesAttendance = [...categoriesAttendance];
                              _categoriesAttendance[i].editable = true;
                              setcategoriesAttendance(_categoriesAttendance);
                            }}
                          >
                            {!e.editable && <IcEditar />}
                          </button>
                        </label>
                      </div>
                    </Accordion.Header>
                    <Accordion.Body>
                      <Row style={{ marginTop: "-1rem" }}>
                        {e.resource.map((e2, i2) => (
                          <Col sm={6} className="mt-3">
                            <div className={styleButton.input_button_list} data-edit={e2.editable}>
                              <label>
                                <input
                                  type="text"
                                  placeholder={`Novo Atendimento`}
                                  value={e2.name}
                                  disabled={!e2.editable}
                                  autoFocus
                                  onChange={ev => {
                                    let _categoriesAttendance = [...categoriesAttendance];
                                    _categoriesAttendance[i].resource[i2].name = ev.target.value;
                                    setcategoriesAttendance(_categoriesAttendance);
                                  }}
                                  onBlur={() => {
                                    let _categoriesAttendance = [...categoriesAttendance];
                                    createResource({
                                      id: e2.id,
                                      name: e2.name,
                                      category_id: e.id,
                                      only_attendance: true,
                                    });
                                    setTimeout(function () {
                                      _categoriesAttendance[i].resource[i2].editable = false;
                                      setcategoriesAttendance(_categoriesAttendance);
                                    }, 100);
                                  }}
                                  onKeyPress={ev => {
                                    if (ev.charCode === 13) {
                                      ev.target.blur();
                                    }
                                  }}
                                />
                                <button
                                  type="button"
                                  className="simple-ico"
                                  onClick={() => {
                                    let _categoriesAttendance = [...categoriesAttendance];
                                    _categoriesAttendance[i].resource[i2].editable = true;
                                    setcategoriesAttendance(_categoriesAttendance);
                                  }}
                                >
                                  {!e2.editable && <IcEditar />}
                                </button>
                              </label>
                            </div>
                          </Col>
                        ))}
                        <Col sm={12}>
                          <button
                            className={`mt-3 ${styleButton.button_add}`}
                            colorScheme="grey"
                            type="button"
                            onClick={() => {
                              let _categoriesAttendance = [...categoriesAttendance];
                              _categoriesAttendance[i].resource.push({
                                editable: true,
                                id: null,
                                name: "",
                              });
                              setcategoriesAttendance(_categoriesAttendance);
                            }}
                          >
                            <span>Adicionar Atendimento ({e.name})</span>
                          </button>
                        </Col>
                      </Row>
                    </Accordion.Body>
                  </Accordion.Item>
                ))}
            </Accordion>
            <button
              className={`mt-3 ${styleButton.button_add}`}
              type="button"
              colorScheme="primary"
              onClick={() => {
                let _categoriesAttendance = [...categoriesAttendance];
                _categoriesAttendance.push({
                  editable: true,
                  id: null,
                  name: "",
                  event: [],
                  resource: [],
                  only_attendance: 1,
                  main_events: 0,
                });
                setcategoriesAttendance(_categoriesAttendance);
              }}
            >
              <span>Adicionar Categoria</span>
            </button>
          </SubContent>
        </Content>
      ) : (
        <Content>
          <Loading />
        </Content>
      )}
    </Main>
  );
}
